import { setUserName, setRegistrationToken } from '@/store/slices/auth/authSlice';
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { isAPIError } from '@/store/utils';
import type { BeginRegistrationDTO } from '@/types/auth/AuthDTOs';
import { setSessionToken } from '@/utils/sessionStorage';

export const verifyOtpThunk = createAppAsyncThunk<
  BeginRegistrationDTO,
  { username: string; otp: string }
>('auth/verifyOtp', async(params, { dispatch, extra: { authService }, rejectWithValue }) => {
  try {
    dispatch(setUserName(params.username));
    const result = await authService.beginRegistration(params);
    dispatch(setRegistrationToken(result.registrationToken));
    setSessionToken(result.registrationToken)
    return result
  } catch (error) {
    if (isAPIError(error) && error.fieldErrors != null) {
      // Correct: rejectWithValue with expected shape
      return rejectWithValue({ fieldErrors: error.fieldErrors });
    }
    throw error;
  }
});
